module.exports = __webpack_public_path__ + "img/k6.2915b493.webp";